
import { defineComponent } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';

export default defineComponent({
  data() {
    return {
      communityPlaylist: [],
      chartsPlaylist: []
    }
  },

 setup() {
    // const revents = [{
    //     'event_name': 'Lewis Concert'
    // }]

    const router = useRouter();
 
    // Optional parameters to pass to the swiper instance. See http://idangero.us/swiper/api/ for valid options.
    const slideOpts = {
      slidesPerView: 3,
      spaceBetween: 10,
      initialSlide: 0,
      speed: 100,
      breakpoints: {
        // when window width is >= 320px
        320: {
        slidesPerView: 2,
        spaceBetween: 0
        },
        // when window width is >= 480px
        768: {
        slidesPerView: 3,
        spaceBetween: 30
        },
        // when window width is >= 640px
        1024: {
        slidesPerView: 5,
        spaceBetween: 0
        }
    }
    };

    return { slideOpts, router }
  },
  methods: {
    redirect(id: string){
      console.log("CLICKED");
        this.router.push('/music/playlist/p/' + id);
    },
    getPlaylistDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    },
    getChartsDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    }
  },
  mounted() {   
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getUserPlaylist?userId=' + localStorage.getItem("userID"))
      .then(
          res => this.communityPlaylist = res.data)
          


           window.addEventListener('playlist-deleted', event => {
      
                   axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getUserPlaylist?userId=' + localStorage.getItem("userID"))
      .then(
          res => this.communityPlaylist = res.data)
           
          }, false);
  } 
});
